import { LocalDate, DateRange, RangePreset } from './types';
import { addDays, addMonthsClamped } from './dateHelpers';

// 'custom' se fija haciendo clic en el calendario (Fase 2), no por preset.
type MovableRangePreset = Exclude<RangePreset, 'custom'>;

// Las ventanas móviles terminan hoy. Hoy es un día parcial, pero no distorsiona
// la comparación: resolveCutoff recorta A y B a la misma hora de reloj.
const rangeFromPreset = (preset: MovableRangePreset, today: LocalDate): DateRange => {
  if(preset === 'today') {
    return { start: today, end: today };
  }
  if(preset === 'yesterday') {
    const day = addDays(today, -1);
    return { start: day, end: day };
  }
  const end = today;
  switch(preset) {
    case '1w':
      return { start: addDays(end, -6), end };
    case '2w':
      return { start: addDays(end, -13), end };
    case '1m':
      return { start: addDays(addMonthsClamped(end, -1), 1), end };
    case '1y':
      return { start: addDays(addMonthsClamped(end, -12), 1), end };
  }
};

export { rangeFromPreset, MovableRangePreset };
